<div class="d-flex align-items-end mb-3">
    <h1 class="fs-3 fw-light mb-0">Funcionários</h1>
    <button mat-flat-button color="primary" class="ms-auto" (click)="showFormDialog()">NOVO FUNCIONÁRIO</button>
</div>
<generate-table 
    [dataSource]="dataSource" [columns]="columns" [loading]="loading"     
    (pageEvent)="search($event)"
></generate-table>